import { createContext, useContext, type ReactNode } from "react";

const EmbedContext = createContext(false);

/** True inside a connected app step, where the app supplies the project bar and the About text. */
export const useEmbedded = () => useContext(EmbedContext);
export function EmbeddedProvider({ children }: { children: ReactNode }) {
  return <EmbedContext.Provider value={true}>{children}</EmbedContext.Provider>;
}
